import { Inject, Injectable } from '@angular/core';
import { ComponentType, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { DateTime } from 'luxon';
import { SPINNER_OVERLAY_COMPONENT_TYPE } from './spinner-overlay.model';

@Injectable({ providedIn: 'root' })
export class SpinnerOverlayService {
  public overlayRef: OverlayRef;

  private counter: number = 0;
  private startTime?: number;
  private endTime?: number;

  public constructor(
    private readonly overlay: Overlay,
    @Inject(SPINNER_OVERLAY_COMPONENT_TYPE) private readonly componentCtr: ComponentType<unknown>,
  ) {
    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      hasBackdrop: true,
    });
  }

  public showLoader(): void {
    if (this.counter === 0 && !this.overlayRef.hasAttached()) {
      this.startTime = DateTime.now().toMillis();
      this.overlayRef.attach(new ComponentPortal(this.componentCtr));
    }

    this.counter += 1;
  }

  public hideLoader(delay: number = 0): void {
    if (this.counter > 0) {
      this.counter -= 1;
    }

    if (this.counter > 0) {
      return;
    }

    if (!this.overlayRef.hasAttached()) {
      return;
    }

    this.endTime = DateTime.now().toMillis();
    // extend the time the spinner is shown if duration is below 500ms
    // to prevent flickering
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentDuration: number = this.endTime - this.startTime!;
    const minDuration: number = 500;

    if (currentDuration + delay < minDuration) {
      delay += minDuration - (currentDuration + delay);
    }

    setTimeout(() => void this.overlayRef.detach(), delay);
  }
}
